<template>
  <div class="map-wrapper">
    <el-dialog title="定位" :visible="show" width="600px" @close="dialogClose" top="20vh" :close-on-click-modal="false">
      <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult" />
      <el-amap id="amap" ref="amap" :center="newCenter" :zoom="zoom" :events="events" :plugin="plugin" :vid="'amap-vue'">
        <!-- defaultCursor="default" -->
        <!-- 标记 -->
        <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :events="marker.events"
          :visible="marker.visible" :draggable="marker.draggable" :vid="index" :key="index"></el-amap-marker>
      </el-amap>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  data () {
    return {
      // center: [116.397425, 39.909287],
      zoom: 14,
      newCenter: [],
      searchOption: {
        city: "全国",   //范围
        citylimit: false, //是否限制城市内搜索
      },
      markers: [
        {
          position: [116.397425, 39.909287],
          events: {},
          visible: true,
          draggable: false,
          template: "<span>1</span>",
        },
      ],
      plugin: [
        // {
        //   pName: "Geolocation",
        //   defaultType: 0,
        //   events: {
        //     load (e) {
        //       console.log("eeeee", e);
        //     },
        //   },
        // },
        // {
        //   pName: "ToolBar",
        //   defaultType: 0,
        // },
        {
          pName: "OverView",
          defaultType: 0,
        },
        {
          pName: "Marker",
          defaultType: 0,
          events: {
            click (o) {
              console.log("ooooooo", o);
            },
          },
        },
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            click (o) {
              console.log("ooooooo", o);
            },
          },
        },
      ],
      mapData: {
        districtCode: "",
        addressDetail: "",
        lng: 116.397425,
        lat: 39.909287
      },
      events: {
        click: (e) => {
          let { lat, lng } = e.lnglat;
          console.log(e);
          this.mapData.lng = lng;
          this.mapData.lat = lat;
          this.markers[0].position = [lng, lat];
          let url = "https://restapi.amap.com/v3/geocode/regeo";
          axios.get(url, {
            params: {
              key: "5b53822df7d7324e6306268237692ba6",
              location: lng + "," + lat,
            },
          }).then((res) => {
            console.log("地图点击", res);
            this.mapData.districtCode = res.data.regeocode.addressComponent.adcode;
            let formatted_address = res.data.regeocode.formatted_address;
            let township = res.data.regeocode.addressComponent.township;
            if (township.length == 0 || !township) {
              this.mapData.addressDetail = formatted_address;
            } else {
              let address = formatted_address.split(township)[1];
              this.mapData.addressDetail = `${township}${address}`;
            }
          });
        },
      },
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Array,
      default: [116.397425, 39.909287],
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.markers[0].position = this.center;
        this.newCenter = this.center;
      }
    }
  },
  created () { },
  methods: {
    dialogClose () {
      this.$emit("update:show", false);
    },
    confirm () {
      this.$emit("mapParams", this.mapData);
      console.log(this.mapData);
      this.$emit("update:show", false);
    },
    onSearchResult (pois) {
      console.log(pois);
      this.markers[0].position = [pois[0].lng, pois[0].lat];
      this.newCenter = [pois[0].lng, pois[0].lat];
      this.mapData = {
        addressDetail: pois[0].name,
        lat: pois[0].lat,
        lng: pois[0].lng
      }
    },
  },
};
</script>

<style lang="less" scoped>
.map-wrapper {
  width: 100%;

  .search-box {
    width: 100%;

    .search-tips {
      width: 100%;
    }
  }

  /deep/.el-dialog__body {
    width: 100%;
    height: 500px;
    box-sizing: border-box;
    overflow-y: visible !important;

    #amap {
      width: 100%;
      height: calc(100% - 45px);

      /deep/.amap-toolbar {
        right: 10px;
        bottom: 10px;
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;

    .btn {
      padding: 0;
      width: 105px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 4px;
      border: 1px solid #717171;
    }

    .btn_ok {
      background: #255A7E;
      color: #fff;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue